<template>
	<v-card height="45" dark>				        
		<v-row dense  >
			<v-col cols="auto" >
				<v-icon>mdi-filter</v-icon>
			</v-col>
			<v-col cols="auto">
				<v-divider vertical ></v-divider>
			</v-col>
			<v-col cols="5">
				<!-- <v-card >						 -->
					<v-slider
						dense
				        v-model="infoToFilter.similarity"
				        prepend-icon="mdi-greater-than-or-equal"
				        append-icon="mdi-percent"
				        :thumb-size="20"
				        thumb-label="always"
				        :label="$ml.get('similarity')"
				        min="0"
				        max="100"
				        color="primary"
				        @end="renderSimilarity"
				        @click="renderSimilarity(infoToFilter.similarity)"
				    >
				        <!-- @change="renderSimilarity" -->
				      	<template v-slot:thumb-label="{ value }">
				            {{ Math.round(value) }}
				        </template>
				    </v-slider>
				<!-- </v-card> -->
				
			</v-col>
		</v-row>
	</v-card>
</template>
<script type="text/javascript">
	export default{
		name: "FilterSearchByVideoResults",
		props:[ "infoToFilter","listToComponent"],
		data : ()=>({
			// similarity: 0,

		}),
		methods:{
			renderSimilarity(value){
				if(this.infoToFilter?.results && this.infoToFilter.results.length){
					const percent=(value/100);
					this.infoToFilter.results.forEach(x=>{
						// x.maxProb = Math.max(...x.data.map(d => d.similarity));						
						x.dataFilter=x.data.map((z, index, arr) => {
						// Incluye el primer y último elemento
						let newItem = { ...z };

						// Incluye el primer y último elemento sin cambios
						if (index === 0 || index === arr.length - 1) {
							//return newItem;
						}

						// Filtra por similarity >= percent
						if (newItem.similarity <= percent) {
							//newItem.similarity = percent;
						}

						return newItem;
						});
					})
				}				
			}
		}
	}
</script>